import { render, staticRenderFns } from "./Doctor.vue?vue&type=template&id=17fa2c1b&"
import script from "./Doctor.vue?vue&type=script&lang=js&"
export * from "./Doctor.vue?vue&type=script&lang=js&"
import style0 from "./Doctor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports